import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { H5, P } from '../../../AbstractElements';
import { AllTimeBrowserUserStatus, BrowserStatusTitle } from '../../../Constant';
import BrowserUseList from './BrowserUseList';

const BrowserStatus = () => {
  return (
    <Col md='12' sm='6'>
      <Card className='browser-status'>
        <CardHeader className='card-no-border pb-0'>
          <H5>{BrowserStatusTitle}</H5>
          <div className='center-content'>
            <P>{AllTimeBrowserUserStatus}</P>
          </div>
        </CardHeader>
        <CardBody>
          <BrowserUseList />
        </CardBody>
      </Card>
    </Col>
  );
};

export default BrowserStatus;
